import { forwardRef } from "react";

import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { useSearchAdminPermissions } from "../../provider/hooks";
import { useSearchPageContext } from "../../provider/SearchPageProvider";
import { useContentSettings } from "../../SearchContentSettings/hooks";
import { ContentSettingsToggle } from "./ContentSettingsToggle";
import { visibilityPermissionsContainerCss } from "./VisibilityPermissions.styles";

export const VisibilityPermissions = () => {
  const {
    getters: { sendAdminContentSettings },
    handlers: { setSendAdminContentSettings },
  } = useSearchPageContext();

  const {
    hasContentSettingGroups,
    setApplyPermissionsModalActive,
    disableContentSettingsRef,
    triggerApplyPermissionsModalRef,
    contentSettingsToggleEnabled,
  } = useAdminContentSettingsContext();

  const { data: user } = useUser();
  const { canModifyContentSettings } = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });
  const { invokeContentSettingsSearchModeChange } = useContentSettings();
  const { blockFilterChanges, isContentSettingsFormDirty } =
    useSearchAdminPermissions();

  const handleToggle = () => {
    setSendAdminContentSettings(!sendAdminContentSettings);

    if (isContentSettingsFormDirty && blockFilterChanges) {
      setApplyPermissionsModalActive(true);
      disableContentSettingsRef.current = true;
    } else {
      invokeContentSettingsSearchModeChange();
    }
  };

  return (
    <>
      {hasContentSettingGroups && canModifyContentSettings && (
        <div
          css={visibilityPermissionsContainerCss(contentSettingsToggleEnabled)}
        >
          <ContentSettingsToggle
            checked={contentSettingsToggleEnabled}
            onChange={handleToggle}
            ref={triggerApplyPermissionsModalRef}
          />
        </div>
      )}
    </>
  );
};

export default forwardRef(VisibilityPermissions);
